import React from "react";

import Layout from "../components/layout";
import Demo from "../components/Demo";

import SEO from "../components/seo";

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <h1 className="mt-10 text-block font-bold text-5xl text-center">
      Learn a language by{" "}
      <span className="bg-highlight rounded px-2 py-1">reading</span>.
    </h1>
    <div className="">
      <Demo></Demo>
    </div>
  </Layout>
);

export default IndexPage;
